<template>
  <main>
    <div class="banner-wrapper" v-if="!contentServiceActive">
      <ag-state-banner
        :inactive-status="true"
        class="ag-state-banner--standalone"
      />
    </div>
    <section class="content-wrapper">
      <ag-header
        title="Content Service"
      />
      <div class="content__body">
        <div v-if="!contentServiceActive">
          <h3 class="content__headline">
            Inhalte für Ihre Homepage: Fachlich relevant - stets aktuell!
          </h3>
          <p class="content__text">
            <em>„Content is king.“</em> (Bill Gates)<br>
            Zeigen Sie Ihren Homepage-Besuchern, dass Sie fachlich immer auf
            dem neuesten Stand sind und binden Sie aktuelle Inhalte auf Ihrer Homepage ein.
          </p>

          <ul>
            <li>Das aktuelle Urteil</li>
            <li>Artikel zu relevanten Rechtsthemen</li>
            <li>Artikel zu relevanten Steuerthemen</li>
            <li>aktuelle Linkliste</li>
          </ul>

          <p class="content__text">
            Die Aktualisierung der Inhalte erfolgt automatisch über unsere Datenbank.
            So profitieren Sie von stets aktuellen Inhalten, ohne selbst ständig Zeit
            und Arbeit in Ihre Homepage zu investieren.
          </p>

          <h4 class="content__headline">
            Kontaktformular
          </h4>

          <p class="content__text">
            Machen Sie es Ihren Mandanten einfach - mit einem Kontaktformular direkt auf Ihrer
            Homepage geben Sie potenziellen Klienten immer und überall die Möglichkeit, sich
            unverbindlich an Sie zu wenden.
          </p>

          <h4 class="content__headline">
            Routenplaner
          </h4>

          <p class="content__text">
            Lassen Sie sich von Ihren Klienten einfacher finden. Mit der Einbindung Ihres
            Standortes über einen Online-Kartendienst erhalten Besucher mit einem Klick die
            bestmögliche Route zu Ihrer Kanzlei.
          </p>

          <p class="content__text">
            Unsere Content-Bausteine können Sie <strong>modular und frei kombinieren</strong>.
            Ob als Rundum-Sorglos-Paket oder als dynamischer Akzent auf Ihrer Kanzlei-Homepage.
          </p>

          <h4 class="content__headline">
            Erfahren Sie hier mehr:
          </h4>

          <a
            class="button-link"
            href="https://www.advogarant.de/marketing/rechtsanwaelte/upgrade-homepage/"
            target="_blank"
          >
            Für Rechtsanwälte
          </a>

          <a
            class="button-link"
            href="https://www.advogarant.de/marketing/steuerberater/upgrade-homepage/"
            target="_blank"
          >
            Für Steuerberater
          </a>

          <p class="content__text">
            Sie haben Fragen, Anmerkungen oder Verbesserungsvorschläge?
            Wir freuen uns über Ihre Anfrage oder Ihr Feedback!
          </p>
        </div>
        <div v-if="contentServiceActive">
          <h3 class="content__headline">
            Inhalte für Ihre Homepage: Fachlich relevant - stets aktuell!
          </h3>

          <p class="content__text">
            <em>„Content is king.“</em> (Bill Gates)<br>
            Zeigen Sie Ihren Homepage-Besuchern, dass Sie fachlich immer auf dem neuesten
            Stand sind und binden Sie aktuelle Inhalte auf Ihrer Homepage ein.
          </p>

          <ul>
            <li>Das aktuelle Urteil</li>
            <li>Artikel zu relevanten Rechtsthemen</li>
            <li>Artikel zu relevanten Steuerthemen</li>
            <li>aktuelle Linkliste</li>
          </ul>

          <p class="content__text">
            Die Aktualisierung der Inhalte erfolgt automatisch über unsere Datenbank.
            So profitieren Sie von stets aktuellen Inhalten, ohne selbst ständig Zeit
            und Arbeit in Ihre Homepage zu investieren.
          </p>

          <p class="content__text">
            Unsere Content-Bausteine können Sie <strong>modular und frei kombinieren</strong>.
            Ob als Rundum-Sorglos-Paket oder als dynamischer Akzent auf Ihrer Kanzlei-Homepage.
          </p>

          <p class="content__text">
            Sie haben Fragen, Anmerkungen oder Verbesserungsvorschläge?
            Wir freuen uns über Ihre Anfrage oder Ihr Feedback!
          </p>
        </div>
        <ag-info-box />
      </div>
    </section>
  </main>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';
import AgStateBanner from '@/components/shared/AgStateBanner.vue';
import AgInfoBox from '@/components/shared/AgInfoBox.vue';

export default {
  name: 'content-service',
  components: {
    AgHeader,
    AgStateBanner,
    AgInfoBox,
  },
  metaInfo: {
    title: 'Content Service',
  },
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  computed: {
    contentServiceActive() {
      return this.activeServices.find((service) => service.key === 'iframe-content-service');
    },
  },
};
</script>

<style lang="scss">
</style>
